import React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";
import App from "./App";

// Find the root div in your HTML
const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

// Create the root and render your app
const root = createRoot(container);
root.render(
  <MsalProvider instance={msalInstance}>
    <App />
  </MsalProvider>
);
